import { Component, Input } from "@angular/core";

@Component({
	selector: "jhm-loading",
	templateUrl: "./loading.component.html",
	styleUrls: ["./loading.component.scss"],
	standalone: true
})
export class LoadingComponent
{
	@Input() public showText: boolean = true;
}
